// client/src/components/ContactForm.js
import React, { useState } from 'react';
import config from '../config/config';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    success: false,
    error: null
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      setStatus({
        ...status,
        error: 'Bitte alle Felder ausfüllen'
      });
      return;
    }

    // Email validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({
        ...status,
        error: 'Bitte gib eine gültige E-Mail-Adresse ein'
      });
      return;
    }

    setStatus({ ...status, submitting: true, error: null });

    try {
      // Add a honeypot check (if website field is filled, it's likely a bot)
      const formDataWithHoneypot = {
        ...formData,
        website: document.getElementById('website-honeypot')?.value || ''
      };

      const response = await fetch(`${config.apiUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formDataWithHoneypot)
      });

      if (!response.ok) {
        throw new Error('Netzwerkfehler beim Senden der Nachricht');
      }

      const data = await response.json();
      
      if (data.success) {
        setStatus({
          submitting: false,
          submitted: true,
          success: true,
          error: null
        });
        
        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          message: ''
        });
        
        // Reset success message after 5 seconds
        setTimeout(() => {
          setStatus(prev => ({
            ...prev,
            submitted: false
          }));
        }, 5000);
      } else {
        throw new Error(data.error || 'Ein Fehler ist aufgetreten');
      }
    } catch (error) {
      setStatus({
        submitting: false,
        submitted: true,
        success: false,
        error: error.message
      });
    }
  };

  return (
    <div className="contact-form-container" id="kontakt">
      <h4>Kontakt</h4>
      
      {status.submitted && status.success && (
        <div className="success-message">
          <i className="fas fa-check-circle"></i>
          Deine Nachricht wurde erfolgreich gesendet!
        </div>
      )}
      
      {status.submitted && !status.success && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle"></i>
          {status.error || 'Ein Fehler ist aufgetreten'}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="footer-contact-form">
        <div className="form-group">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Dein Name"
            className="form-input"
            disabled={status.submitting}
            aria-label="Name"
          />
        </div>
        
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Deine E-Mail"
            className="form-input"
            disabled={status.submitting}
            aria-label="Email"
          />
        </div>
        
        <div className="form-group">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Deine Nachricht"
            className="form-input"
            rows="3"
            disabled={status.submitting}
            aria-label="Nachricht"
          ></textarea>
        </div>
        
        {/* Honeypot field - hidden from users but bots will fill it */}
        <input
          type="text"
          id="website-honeypot"
          name="website"
          style={{ opacity: 0, position: 'absolute', height: 0 }}
          tabIndex="-1"
          aria-hidden="true"
        />
        
        <button 
          type="submit" 
          className="contact-submit-btn"
          disabled={status.submitting}
        >
          {status.submitting ? (
            <>
              <i className="fas fa-spinner fa-spin"></i>
              Wird gesendet...
            </>
          ) : 'Nachricht senden'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;